import { Route } from '@angular/router';
import { unsavedChangesGuard } from '@ami/angular/core/auth';
import { Type } from '@angular/core';

export function reactWrapperRoute(component: Type<any>): Route {
  return { path: '**', canDeactivate: [unsavedChangesGuard], component: component };
}
